module.exports = __webpack_public_path__ + "static/media/arrow-white-icon.b3736984.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-white-icon.svg
// module id = 263
// module chunks = 0